'use client';

import { Button, Icon } from '@mage-ui/components';
import { cx } from '@mage-ui/styled-system/css';
import {
	flexWrapper,
	icon,
	shopCard,
	text,
} from '@mage-ui/styled-system/recipes';
import Link from 'next/link';
import { useContext } from 'react';
import { useCart } from '@/components/context/CartProvider';
import { StaticTextContext } from '@/components/context/StaticTextProvider';
import { toast } from '@/components/ui/data-display/toast/Toast';

export const ShopCardFooter = ({ data }) => {
	const { st } = useContext(StaticTextContext);
	const { addItem } = useCart();
	const handleClick = () => {
		addItem({
			cartItemId: crypto.randomUUID(),
			id: data?.id,
			name: data?.name,
			price: data?.price,
		});

		toast({
			title: (
				<div className={flexWrapper({ align: 'center', gap: 'gap300' })}>
					{data?.name} {st('cart.item_added')}
					<Link href={data.cartLink} className={cx(text({ size: '4' }))}>
						{st('cart.go_cart')}
					</Link>
				</div>
			),
			status: 'success',
			autoClose: 3000,
			position: 'bottom-center',
		});
	};
	return (
		<div className={shopCard().bottomContent}>
			<Button
				onClick={handleClick}
				leftSection={
					<Icon
						classNames={icon({ size: 'm' })}
						name='cart'
						aria-hidden='true'
					/>
				}
			>
				{st('cart.add_item')}
			</Button>
		</div>
	);
};
